import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import LanguageDropdown from "Components/Common/LanguageDropdown";
import { useTranslation } from "react-i18next";
import { createPublicToken } from "../../helpers/dataBackend";
import { setAuthorization } from "../../helpers/api_helper";

const SelectionType = () => {
  //meta title
  document.title = "Ditobanx";
  const { t } = useTranslation();

  const getPublicToken = async () => {
    const responsePublicToken = await createPublicToken();
    // console.log(responsePublicToken);
    localStorage.setItem("publicToken", responsePublicToken.token);
    setAuthorization(responsePublicToken.token); // Guardar el token antes de continuar
  };

  useEffect(() => {
    getPublicToken();
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="text-center mt-5" style={{ width: "100%" }}>
          <Row className="justify-content-center mt-lg-5">
            <Col xl={5} sm={8}>
              <Card>
                {/* CAMBIO DE IDIOMA */}
                <div
                  style={{ position: "absolute", right: "10px", top: "10px" }}
                >
                  <LanguageDropdown />
                </div>
                <div
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <h2 className="mb-3">{t("Welcome to DitoBanx !")}</h2>
                  <p>{t("Select an account type")}</p>
                </div>
                <CardBody>
                  <div id="kyc-verify-wizard" className="wizard clearfix">
                    <Row className="gx-4">
                      <Col md={6}>
                        <Card className="shadow-sm">
                          <CardBody className="py-4">
                            <div className="">
                              {/* Ícono de Persona Natural */}
                              <i
                                className="mdi mdi-account-multiple"
                                style={{ fontSize: "100px" }}
                              ></i>
                            </div>
                            <h5 className="mb-2">{t("Natural Person")}</h5>
                            <p className="text-muted">
                              {t("For personal use")}
                            </p>
                            <Link to="/individual-registration" color="primary">
                              {t("Select")}
                            </Link>
                          </CardBody>
                        </Card>
                      </Col>

                      <Col md={6}>
                        <Card className="shadow-sm">
                          <CardBody className="py-4">
                            <div>
                              {/* Ícono de Empresa */}
                              <i
                                className="mdi mdi-domain"
                                style={{ fontSize: "100px" }}
                              ></i>
                            </div>
                            <h5 className="mb-2">{t("Enterprise")}</h5>
                            <p className="text-muted">
                              {t("For Businesses and legal person")}
                            </p>
                            <Link to="/business-registration" color="primary">
                              {t("Select")}
                            </Link>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                  <Link to={"/login"} className="btn btn-primary">
                    Volver
                  </Link>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SelectionType;
